import leftArrow from '../assets/leftArrow.svg';
import blueTriangle from '../assets/blueTriangle.png';
import darkBlueLeftArrow from '../assets/darkBlueLeftArrow.svg';
import rightArrow from '../assets/rightArrow.svg';
import arrowDown from '../assets/arrow-down.png';
import darkBlueArrowDown from '../assets/arrow-down.svg';
import arrowUp from '../assets/arrow-up.svg';
import personIcon from '../assets/person-24-px.svg';
import lockIcon from '../assets/lock-24-px.svg';
import close from '../assets/close.svg';
import success from '../assets/success.png';
import successSVG from '../assets/success-svg.svg';
import pending from '../assets/in-progress-icon.svg';
import refused from '../assets/refused-icon.svg';
import successBold from '../assets/success-bold.png';
import successBoldBlue from '../assets/success-bold-blue.png';
import error from '../assets/error.png';
import dollar from '../assets/dollar-sign.png';
import dollarBlue from '../assets/dollar-sign-blue.png';
import returnImageBlue from '../assets/return-blue.png';
import returnImage from '../assets/return.png';
import orangeTriangleLine from '../assets/orange-triangle-line.svg';
import invalidName from '../assets/invalid-name.png';
import email from '../assets/email-24-px.svg';
import emailWhite from '../assets/email-white.svg';
import phone from '../assets/phone-24-px.svg';
import phoneWhite from '../assets/phone-24-px-white.svg';
import document from '../assets/document.svg';
import sunbitLogoFullColor from '../assets/sunbit-logo-full-color-pantone-print.png';
import loaderImage from '../assets/sunbitLoader.gif';
import completed from '../assets/completed.png';
import questionMark from '../assets/question-mark.png';
import visa from '../assets/visa-icon.png';
import amex from '../assets/amex-icon.png';
import mastercard from '../assets/mastercard.png';
import discover from '../assets/discover.png';
import getInfoIcon from '../assets/get-info-icon.svg';
import sunbitLoader from '../assets/sunbitLoader.gif';

export const size = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  mobileXL: 600,
  tabletS: 650,
  tablet: 768,
  laptopS: 800,
  laptopMS: 906,
  laptop: 1024,
  laptopM: 1200,
  laptopL: 1440,
  desktop: 2560,
};

const sizeInPX = new Proxy(size, {
  get: function (target, prop) {
    return target[prop] + 'px';
  },
});

const onlineTheme = {
  font: {
    family: 'Poppins',
    size: {
      smaller: '10px',
      small: '13px',
      smallMedium: '16px',
      smallMedium2: '18px',
      smallMedium3: '20px',
      medium: '22px',
      medium2: '24px',
      medium3: '26px',
      mediumLarge: '30px',
      large: '36px',
      huge: '42px',
      huger: '48px',
      gargantuan: '100px',
    },
    weight: {
      lighter: 200,
      light: 300,
      normal: 400,
      medium: 500,
      bold: 600,
      bolder: 700,
      boldest: 900,
    },
  },
  colors: {
    white: '#fff',
    whiteGray: '#f4f4f4',
    black: '#000',
    light: '#38c5f3',
    light2: '#41c6f2',
    light3: '#00a7e1',
    light4: '#04a6e1',
    light5: '#03a5df',
    dark: '#345275',
    border: '#e0e0e0',
    seperator: '#c0c0c0',
    grayBlueish: '#77888c',
    gray: '#9e9e9e',
    lightgray: '#E5E5E5',
    mediumGray: '#8F97A8',
    grayWhite: '#F1F3F5',
    grayLight: '#f7f7f7',
    grayLight2: '#829099',
    grayDark: 'rgb(74,74,74)',
    primaryDark: '#345374',
    primaryDark2: '#212d65',
    heroBackground: '#FCFCFC',
    darkOpac: 'rgba(52,82,117, 0.6)',
    error: '#f56161',
    error2: '#c8203d',
    error3: '#c8564b',
    warning: '#f5a623',
    disabledBG: '#E7E9EE',
    disabledText: '#BCC1CB',
    disabledButton: '#d8d8d8',
    inputBackground: 'rgba(54, 54, 54, 0.05)',
    tabsBackGround: 'rgba(133,149,159, 0.07)',
    tableHeaderBackground: 'rgba(133,149,159, 0.1)',
    tableBorderBackground: 'rgba(133,149,159, 0.5)',
    placeholder: '#002169',
    placeholder2: '#8090B4',
    placeholderGray: '#c2c2c2',
    sunbitYellow: '#ffc80a',
    headlineGrey: '#8597ad',
    headlineGrey2: '#7897ab',
    headlineGrey3: '#9da6ac',
    headlineGrey4: '#85959f',
    homeBackground: '#f3f9ff',
    inputBorder: '#d1d9e0',
    primary: '#3156DB',
    primaryBackground: '#002169',
    accent: '#FFD179',
    secondaryOrange: '#FF9E4E',
    secondaryIceBlue: '#E6FBFE',
    secondaryDarkGray: '#4A5568',
    desktopBackground: '#FBFCFF',
    darkGray: '#616672',
    primaryBright: '#3156FF',
    brightBlue: '#E0E6FF',
    lightBackground: '#F6F9FC',
    bulletBackground: 'linear-gradient(0deg, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)), #3156FF',
    lightGray: '#A9B5C8',
    lightBlue: '#98abff',
    tintDeepBlue: '#B2BCD2',
    tintBackground: '#F2F4F7',
    blueGrey: '#596F9D',

  },
  desktop: {
    width: 1330,
    height: 780,
  },
  pos: {
    width: 768,
    height: 1024,
  },
  spacing: {
    small: 5,
    smallMedium: 7,
    smallMedium2: 8,
    medium: 10,
    mediumLarger: 15,
    large: 20,
    large2: 25,
    larger: 30,
    larger2: 40,
    huge: 60,
    hugeHuger: 75,
    huger: 90,
    smallerGargantuan: 110,
    gargantuan: 120,
    mobile: 27,
  },
  device: {
    mobileS: `(min-width: ${sizeInPX.mobileS})`,
    mobileM: `(min-width: ${sizeInPX.mobileM})`,
    mobileL: `(min-width: ${sizeInPX.mobileL})`,
    tabletS: `(min-width: ${sizeInPX.tabletS})`,
    tablet: `(min-width: ${sizeInPX.tablet})`,
    laptopS: `(min-width: ${sizeInPX.laptopS})`,
    laptopMS: `(min-width: ${sizeInPX.laptopMS})`,
    laptop: `(min-width: ${sizeInPX.laptop})`,
    laptopM: `(min-width: ${sizeInPX.laptopM})`,
    laptopL: `(min-width: ${sizeInPX.laptopL})`,
    desktop: `(min-width: ${sizeInPX.desktop})`,
    desktopL: `(min-width: ${sizeInPX.desktop})`,
    max: {
      mobileS: `(max-width: ${sizeInPX.mobileS})`,
      mobileM: `(max-width: ${sizeInPX.mobileM})`,
      mobileL: `(max-width: ${sizeInPX.mobileL})`,
      mobileXL: `(max-width: ${sizeInPX.mobileXL})`,
      tabletS: `(max-width: ${sizeInPX.tabletS})`,
      tablet: `(max-width: ${sizeInPX.tablet})`,
      laptopS: `(max-width: ${sizeInPX.laptopS})`,
      laptopMS: `(max-width: ${sizeInPX.laptopMS})`,
      laptopM: `(max-width: ${sizeInPX.laptopM})`,
      laptop: `(max-width: ${sizeInPX.laptop})`,
      laptopL: `(max-width: ${sizeInPX.laptopL})`,
      desktop: `(max-width: ${sizeInPX.desktop})`,
      desktopL: `(max-width: ${sizeInPX.desktop})`,
    },
  },
  borderRadiusCommon: 8,
  borderRadiusMedium: 16,
  borderRadiusButton: {
    small: 24,
    medium: 28,
    mediumLarge: 31.2,
    large: 35.5,
  },
  borderRadiusRound: 2000,
  icons: {
    leftArrow: `"${leftArrow}"`,
    darkBlueLeftArrow: `"${darkBlueLeftArrow}"`,
    rightArrow: `"${rightArrow}"`,
    arrowDown,
    blueTriangle,
    darkBlueArrowDown,
    arrowUp,
    personIcon: `"${personIcon}"`,
    lockIcon: `"${lockIcon}"`,
    close: `"${close}"`,
    success,
    refused,
    pending,
    successSVG,
    error,
    dollar,
    dollarBlue,
    returnImageBlue,
    successBoldBlue,
    successBold,
    returnImage,
    orangeTriangleLine: `"${orangeTriangleLine}"`,
    invalidName,
    email: `"${email}"`,
    emailWhite: `"${emailWhite}"`,
    phone: `"${phone}"`,
    document: `"${document}"`,
    phoneWhite: `"${phoneWhite}"`,
    completed,
    sunbitLogoFullColor,
    loaderSunbit: loaderImage,
    questionMark,
    visa,
    amex,
    mastercard,
    discover,
    getInfoIcon,
    sunbitLoader,
  },
};

export default onlineTheme;
export type OnlineThemeType = typeof onlineTheme;
